module.exports = __webpack_public_path__ + "img/IMG_3945_L_WoodMatted_MockedUp.1c365a79.jpg";